<template>
  <m-dialog  page
             @close="$router.push({name: 'order'})"
             name="geo"
             title="Select Geographic">
    <div  slot="menu" class="m-scroll-v">
      <b-link v-for = "item in geoTabs"
              @click='go(item)'
              class="m-scroll-v-tab"
              :id="'geo-tab-' + item.name"
              :class="{'m-scroll-v-tab-active': item.name === geoOption}"
              :key = "item.name" >
        {{item.title}}
      </b-link>
    </div>

    <m-box >
      <slot></slot>
    </m-box>

    <b-btn style="margin-left: 8px"
           variant="primary"
           @click="$router.push({name: 'order'})">Done</b-btn>

  </m-dialog>
</template>

<script>
  import MGeoSelect from '@/components/geo/MGeoSelect'

  export default {
    components: {
      MGeoSelect
    },
    props: {
      geoOption: {
        type: String,
        default: 'zip'
      }
    },
    data () {
      return {}
    },
    computed: {
      datasource () {
        return this.$store.getters['config/datasource']
      },
      geoTabs () {
        return this.datasource.geoTabs
      }
    },
    activated () {
      setTimeout(() => {
        this.$scrollTo('#geo-tab-' + this.geoOption, 1,
          {x: true, y: false, container: '.m-scroll-v', duration: 1})
      }, 100)
    },
    mounted () {
      setTimeout(() => {
        this.$scrollTo('#geo-tab-' + this.geoOption, 1,
          {x: true, y: false, container: '.m-scroll-v', duration: 1})
      }, 100)
    },
    methods: {
      go (item) {
        if (item.routeName) {
          this.$store.dispatch('order/changeGeoType', item.code)
          if (item.code === 20) {
            this.$store.commit('order/addGeo', {
              GeoKeyCode: '1',
              GeoKeyDesc: 'NATIONWIDE',
              GeoType: item.code
            })
          }
          this.$router.push({name: 'order'})
        } else {
          this.$router.push({name: 'geo-' + item.name})
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/geo/M2GeoBox.vue